import { useState } from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import RequestPageOutlined from "@mui/icons-material/RequestPageOutlined";
import downloadBoleto from "lib/api/download-boleto";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import { downloadNotaDocumento } from "./utils";

export default function DocumentIconButton({
  disponivel,
  tipo,
  chaveNf,
  numeroTitulo,
  formatoArquivo,
  pdfNoS3,
  xmlNoS3,
  preferXml,
  tooltip,
}) {
  const snackbar = useSnackbar();
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async (event) => {
    event.stopPropagation();
    event.preventDefault();

    if (!disponivel || isDownloading) {
      if (!disponivel) {
        snackbar.showMessage("Documento não disponível para download.", {
          severity: "info",
        });
      }
      return;
    }

    setIsDownloading(true);

    try {
      if (tipo === "boleto") {
        await downloadBoleto("encontro-contas", numeroTitulo);
        return;
      }

      if (tipo === "nota") {
        await downloadNotaDocumento({
          chaveNf,
          formatoArquivo,
          pdfNoS3,
          xmlNoS3,
          preferXml,
        });
      }
    } catch (error) {
      snackbar.showMessage(
        error?.message || "Erro ao baixar o documento. Tente novamente.",
        { severity: "error" },
      );
    } finally {
      setIsDownloading(false);
    }
  };

  const tooltipTitle = isDownloading
    ? "Baixando..."
    : disponivel
      ? tooltip
      : "Documento não disponível";

  return (
    <Tooltip title={tooltipTitle}>
      <span>
        <IconButton
          type="button"
          size="small"
          color="primary"
          onClick={handleDownload}
          onMouseDown={(event) => event.stopPropagation()}
          disabled={isDownloading}
          style={{
            cursor: disponivel && !isDownloading ? "pointer" : "not-allowed",
          }}
          aria-label={tooltipTitle}
        >
          <RequestPageOutlined
            fontSize="small"
            color={disponivel && !isDownloading ? "primary" : "disabled"}
          />
        </IconButton>
      </span>
    </Tooltip>
  );
}
